<template>
  <div class="home">
  
    <Reproductor msg="Las Vocales" audio2="../mp3/PrimariaA/01PA.mp3" cover="../img/1.jpg" name="Primaria A - Lección #1"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
